import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from 'vue';
import { CouponInfo, getDetailInfo } from '@tencent/wphk-components-wecoupon';


export default /*#__PURE__*/_defineComponent({
  __name: 'info-list',
  props: {
  info: {
    type: Object as PropType<CouponInfo>,
    required: true,
  },
},
  setup(__props) {

const props = __props



/** 券信息详情列表 */
const list = computed(() => getDetailInfo(props.info));

return { __sfc: true,props, list }
}

})